
import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import router from './router'
import store from './store';
import vuescroll from 'vue-scroll'
import {ColorPicker,Button,Input,Dropdown} from 'element-ui';
import axios from 'axios'
import {api} from '@/api/api.js'
import './font2/iconfont.css'
import './font2/iconfont.js'
import './font3/iconfont.css'
import './font3/iconfont.js'
import './iconfont/iconfont.css'
import './iconfont/iconfont.js'
import './iconfont-mobile/iconfont.css'
import './iconfont-mobile/iconfont.js'
import VueLazyLoad from 'vue-lazyload'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'ant-design-vue/dist/antd.css';
import './assets/style.less'
Vue.use(VueLazyLoad,{
    error:'./assets/error.jpg',
    loading:'./assets/load.jpg'
})

Vue.directive('draggable', {
  bind(el, binding, vnode) {
    let offsetX, offsetY;
    let isDragging = false;

    const startDrag = (e) => {
      // Check if the click target is within the header element
      const headerElement = vnode.context.$refs.header;
      if (!headerElement.contains(e.target)) {
        return;
      }

      isDragging = true;
      offsetX = e.clientX - el.offsetLeft;
      offsetY = e.clientY - el.offsetTop;

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = (e) => {
      if (!isDragging) return;
      el.style.left = `${e.clientX - offsetX}px`;
      el.style.top = `${e.clientY - offsetY}px`;
    };

    const mouseUpHandler = () => {
      isDragging = false;
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    el.addEventListener('mousedown', startDrag);
  },
});
import VueClipboards from 'vue-clipboard2'
import infiniteScroll from 'vue-infinite-scroll'
import APlayer from '@moefe/vue-aplayer';

Vue.use(APlayer, {
  productionTip: true
});
Vue.use(infiniteScroll)
Vue.use(VueClipboards);
Vue.use(vuescroll, { debounce: 500 })
Vue.use(router)
Vue.use(Antd);
Vue.use(ColorPicker,Button,Input,Dropdown);
Vue.component('quillEditor', quillEditor)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$api = api
axios.defaults.timeout = 25 * 1000;

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

